import { useState, useEffect, useRef, useContext } from 'react'
import axios from 'axios'

import { loadingContext, projectContext, urlValue, unfolder, onImportExcelAsync,openAlert } from '../../lib'
import SelectCodeModal from '../SelectCodeModal'
import '../../styles/sideIntent.scss'
import '../../styles/styles.css'
import { useForm } from 'react-hook-form'

import Loading from '../Loading'
import Swal from 'sweetalert2'
import { Tooltip } from 'react-tooltip'
import BoxInfo from '../common/BoxInfo'
import { Alerts } from '../common/Alerts'
import Button from '../provider/button/button.jsx'

export function NewIntent({ setSidePanel, refresh, setRefresh, update }) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [isModalOpen, setIsModalOpen] = useState({ delete: false, code: false })
  const [loading, setLoading] = useContext(loadingContext)
  const [answer, setAnswer] = useState()
  const [category, setCategory] = useState()
  const [compliancePhare, setCompliancePhare] = useState("")
  const [multi_phrase, setMulti_phrase] = useState([])

  const [list, setList] = useState([])
  const phraseInput = useRef()
  const nameInput = useRef()
  const dummy = useRef()
  const input_ref = useRef()
  const output_ref = useRef()
  const [errors, setErrors] = useState({ name: "" })
  const [alert, setAlert] = useState({title: '', visible: false})
  const [csrfToken, setCsrfToken] = useState()
  let phrase = useRef('')
  let name = useRef('')
  const [inputContext, setInputContext] = useState()

  let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
  let user_id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
  let ccms_name = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').ccms_name
  
  useEffect(() => {
    setMulti_phrase([]);
  }, [])
  const getCSRFToken = () => {
    axios({
      method: 'get',
      url: `${urlValue}/studio/project/getCSRFToken`,
      headers: {
        'access-token': token,
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      axios.defaults.headers.common['X-CSRF-Token'] = response.data.CSRFToken
      axios.defaults.headers.common['xsrf-token'] = response.data.CSRFToken

      setCsrfToken(response.data.CSRFToken)

    }).catch(error => {
      console.log('error', error)
    });
  }

  String.prototype.rtrim = function () {
    //removes last space from string when invoked
    return this.replace(/((\s*\S+)*)\s*/, '$1')
  }

  const handleCancel = () => {
    cleanForm()
    update();    
  }

  const Submit = e => {
    e.preventDefault()

    let ok = true
    const exp = /^[A-Za-zÀ-ÿ0-9-,._-ñ;!@'()-¿?\s]+$/g;
    const exp_spaces = /\s/g;
    if (!exp.test(nameInput.current.value)) {
      ok = false;
      setErrors({ ...errors, name: "The name cannot contain symbols and special characters." })
    }
    const input_context = document.querySelector("#input-context").value;
    const output_context = document.querySelector("#output-context").value;

    if (category == null && compliancePhare == "") {
      ok = false
      setErrors({ ...errors, name: "You must select a category and a main sentence" })
    }

    else if (category == null) {
      ok = false
      setErrors({ ...errors, name: "You must select a category" })
    }

    else if (compliancePhare === "") {
      ok = false
      setErrors({ ...errors, name: "You must select a main sentence" })
    }

    if (ok) {
      setLoading(true)
      
      axios({
        method: 'post',
        url: `${urlValue}/studio/project/${selectedProject.id}/intent`,
        headers: {
          'access-token': token,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': true
        },
        data: JSON.stringify({
          displayName: name.current.rtrim(),
          trainingPhrasesParts: list,
          languageCode: selectedProject?.metadata?.language?.slice(0,2),

          multi_phrase,
          compliance_type: category,
          compliance_phare: compliancePhare,
          inputContext: input_context,
          outputContext: output_context,
          user_id: user_id.toString(),
          ccms_name: ccms_name.toString(),
        }),
      })
        .then(function (response) {
          setAnswer(response.data)
          // setList([])
          // nameInput.current.value = ''
          cleanForm();
          update();
          setLoading(false) 
          // setRefresh(refresh + 1)
          openAlert('#alert-ac', () => {setAlert({title: 'Intent have been create properly!', visible: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
   
        })
        .catch(function (error) {
          console.log(error)
          setLoading(false)
          openAlert('#alert-ac', () => {setAlert({title: 'Intent could not save!', visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
         
        })
    }
  }

  const handleIntro = e => {
    if (e.key == 'Enter') {
      addPhrase(e)
    }
  }
  const addPhrase = e => {
    e.preventDefault()
    let ok = true
    const exp = /^[A-Za-zÀ-ÿ0-9-,._-ñ;!@'()-¿?\s]+$/g;
    if (!exp.test(phraseInput.current.value)) {
      openAlert('#alert-ac', () => {setAlert({title: 'Some characters are not allowed!', visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
      ok = false;
    }

    if (phraseInput.current.value.length > 768) {
      openAlert('#alert-ac', () => {setAlert({title: 'The sentence is very long, it cannot exceed 768 characters!', visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
      ok = false;
    }

    if (ok) {
      setList(prev => [...prev, phrase.current.rtrim()])
      phraseInput.current.value = ''
    }

  }
  const removePhrase = e => {
    e.preventDefault()
    let end = e.target.previousSibling.innerText.length
    let element = e.target.previousSibling.innerText.slice(2, end)
    setList(prev => prev.filter(e => e !== element))
  }
  const removePhrase2 = (index, phrase) => {
    setList(prev => prev.filter((e, i) => i !== index))
    setMulti_phrase(prev => prev.filter(x => x !== phrase))
  }

  useEffect(() => {
    if (dummy.current) {
      // dummy.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [list])

  const changeCategory = e => {
    document.querySelectorAll(".categories_list .checkbox").forEach(element => element.checked = false);
    e.target.checked = true;
    switch (e.target.id) {
      case "compliance":
        setCategory(1);
        break;
      case "resolution":
        setCategory(2);
        break;
      case "conversation":
        setCategory(3);
        break;
      case "disclaimer":
        setCategory(4);
        break;
      default:
        break;
    }
  }

  const changePhrase = (e, phrase) => {

    if (e.target.checked) {
      setMulti_phrase([...multi_phrase, phrase])
    } else {
      setMulti_phrase(prev => prev.filter(x => x !== phrase))
    }
    if (category === 4) {
      document.querySelectorAll(".newPhrases .checkbox").forEach(element => element.checked = false);
      e.target.checked = true;
      setMulti_phrase([phrase])
    }
    setCompliancePhare(phrase);
  }
  const [IntentstExcel, setIntentstExcel] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false)


  const uploadMaxive = async () => {

    if (!loadingUpload && IntentstExcel.length > 0 && IntentstExcel.length <= 101) {

      setLoadingUpload(true)
      setTimeout(async () => {

        const DatosFormat = [...IntentstExcel].map((item, index) => {
          let split = item.Training_Phrases.split("--");
          split = split.filter(x => x.trim() !== "");
          const fraseSelecionada = split.find(x => x[0] === "*");
          split = split.map(ph => (ph.replace("*", "")?.trim()));
          return { ...item, Training_Phrases: split, CompliancePhare: fraseSelecionada.replace("*", "")?.trim() };
        });
        for (var i = 0; i < DatosFormat.length; i++) {

          let CategoryExcel = 1;
          switch (DatosFormat[i].Category) {
            case "Compliance":
              CategoryExcel = 1;
              break;
            case "Resolution":
              CategoryExcel = 2;
              break;
            case "Conversation":
              CategoryExcel = 3;
              break;

            default:
              break;
          }
          const dataSend = JSON.stringify({
            displayName: DatosFormat[i].Name?.trim(),
            trainingPhrasesParts: DatosFormat[i].Training_Phrases,
            languageCode: selectedProject?.metadata?.language?.slice(0,2),
            compliance_type: CategoryExcel,
            compliance_phare: DatosFormat[i].CompliancePhare,
          })
          const rest = await axios.post(`${urlValue}/studio/project/${selectedProject.id}/intent`,
            dataSend,
            {
              headers: {
                'access-token': token,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': true
              },

            })
        }
        setLoadingUpload(false)
        window.location.reload();
      }, 2000)

    } else {
      alert("Cannot insert more than 100 lines")
    }

  }
  const prepareExcel = async (file) => {
    const DatosExcel = await onImportExcelAsync(file);
    setIntentstExcel(DatosExcel);
    uploadMaxive();

  }
  const cleanForm = () => {
    setList([])
    nameInput.current.value = ''
    setErrors({ ...errors, name: "" })
    document.querySelectorAll(".categories_list .checkbox").forEach(element => element.checked = false);
    setCompliancePhare("")
    setMulti_phrase([])
    input_ref.current.value = ''
    output_ref.current.value = ''
    phraseInput.current.value = ''
  }

  const changePhraseName = (e, index) => {
    if (e.target.value) {
      const multiNew = [...multi_phrase]
      if (compliancePhare === multiNew[index])
        setCompliancePhare(e.target.value);

      multiNew[index] = e.target.value;
      setMulti_phrase(multiNew)
    } 
  }

  useEffect(() => {
    setTimeout(() => {
    let textareas = document.querySelectorAll(".box-text")
   
      textareas.forEach((element) => {
        element.style.height = `${element.scrollHeight}px`
      
    })    
  }, 400)
  }, [])
  return (
    <div className="newIntent editIntent" id="intents">
      <div className="Intent">
        <div className="  scroll-internal-intents ">
          <div className="IntTitle">
            <h2>Create Intent Set</h2>
          </div>
          <form className="form_intent_create" onKeyPress={handleIntro} onSubmit={Submit}>
            <input id="csrf" type="hidden" name="_csrf" value="{{csrfToken}}" />
            <div className=" ">

              <div className="flex ">
                <div className="con_name flex-1">
                  <label className="label">Name:</label>
                  <input
                    id='name-tp'
                    type="text"
                    placeholder="Enter the Intent name"
                    className='input-data'
                    onChange={e => (name.current = e.target.value.toUpperCase())}
                    ref={nameInput}
                  />
                  <Tooltip anchorSelect="#name-tp" content={"Only these characters are accepted A-Za-z0-9-,._'"} place={"top"} />
                </div>

                <div className="flex-1">
                  <div className="con_categories">
                    <BoxInfo
                      id="ramvoice-tp"
                      titleClass='mr-0-4 color-label f-16  title-intent'
                      title="Category"
                      place="top"
                      containerClass='mr-0-5 z-15 '
                      render={`<div>
                          In this section, you must choose one of the options below. <br />
                          Compliance:   phrase or interaction that needs to be performed by the agent during a call.<br />
                          Resolution: phrase or interaction that resolves the inquiries, issues, or problems for which the customer is calling for. It is used to commonly end the call.<br />
                          Conversation:  phrases or parts of a conversation that are not required to perform but It allows the agent to have a common conversation that  <br /> is not mandatory to do in the call-flow and doesn’t affect the call.<br />
                          Disclaimer: phrases or pieces of information that must be given to the customer because are mandatory and cannot be omitted.<br />
                        </div>`}
                    />
                    <div className="categories_list">
                      <div className="item">
                        <input id="compliance" type="checkbox" className="checkbox" onChange={changeCategory} />
                        <label htmlFor="compliance" className='sub-title-intent'>Compliance</label>
                      </div>
                      <div className="item">
                        <input id="resolution" type="checkbox" className="checkbox" onChange={changeCategory} />
                        <label htmlFor="resolution" className='sub-title-intent'>Resolution</label>
                      </div>
                      <div className="item">
                        <input id="conversation" type="checkbox" className="checkbox" onChange={changeCategory} />
                        <label htmlFor="conversation" className='sub-title-intent'>Conversation</label>
                      </div>
                      <div className="item">
                        <input id="disclaimer" type="checkbox" className="checkbox" onChange={changeCategory} />
                        <label htmlFor="disclaimer" className='sub-title-intent'>Disclaimer</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full ">
                <label className="label-title title-intent" style={{ fontSize: 18 }}>Context:</label>

                <div className='flex items-center'>
                  <div className="con_name">
                    <label className="label-child sub-title-inten" style={{ fontSize: 15 }}>Input context</label>
                    <input
                      id="input-context"
                      ref={input_ref}
                      type="text"
                      className='input-data'
                      onChange={() => { }}
                    />
                  </div>

                  <div className="con_name" style={{ marginLeft: 7 }}>
                    <label className="label-child sub-title-intent" style={{ fontSize: 15 }}>Output context</label>
                    <input
                      ref={output_ref}
                      id="output-context"
                      type="text"
                      className='input-data'
                      onChange={() => { }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="con_training_phrases">
              <label className="label title-intent">Training phrases:</label>

              <div className="addPhrase  ">
                <input
                  id='train-tp'
                  type="text"
                  placeholder='Enter the phrases to train the AI'
                  ref={phraseInput}
                  className='input-data'
                  onChange={e => (phrase.current = e.target.value)}
                />
                {/* <span className="tooltiptext">Only these characters are accepted A-Za-z0-9-,._'¿? <div className='triangulo'></div></span> */}
                <Tooltip anchorSelect="#train-tp" content={"Only these characters are accepted A-Za-z0-9-,._'"} place={"top"} />
                <img id="add-tp" alt='' onClick={addPhrase} src="/icons/add-icon-nt.png" style={{ width: 52, height: 28, objectFit: 'contain', cursor: 'pointer' }} />
                {/* <a onClick={addPhrase} className="addsOrSubs">
              </a> */}
                <Tooltip anchorSelect="#add-tp" content={"Add phrase"} place={"top"} />
              </div>

              {list.length !== 0 && (
                <div className="newPhrases" style={{ overflowY: "hidden" }}>
                  <div className="sub-phrase-scroll">
                    {list.map((element, index) => (
                      <div className="rendered" key={index}>
                      <textarea phrase={element} defaultValue={element} className='edit-input box-text' style={{border:'none', resize: 'none', width: "100%", marginRight: 7, }} onChange={(e) => changePhraseName(e, index)}  ></textarea>
                      {/* <input type="text" phrase={element} defaultValue={element} className='edit-input' style={{marginRight: 7}} onChange={(e) => changePhraseName(e, index)} /> */}
                        <div className="phrase_selection">
                          {/* <img alt="" src={'/icons/edit-icon.png'}  className="edit-icon-phrase"/> */}
                          <input type="checkbox" className="checkbox" onChange={(e) => changePhrase(e, element)} />
                          <a className="addsOrSubs" onClick={() => removePhrase2(index, element)} >
                            -
                          </a>
                        </div>

                      </div>
                    ))}
                    <div ref={dummy}></div>
                  </div>
                </div>
              )}
            </div>

            <div className="buttons">
              {/* <button className="blue-secondary" onClick={handleCancel}>
              Cancel
            </button> */}

              <Button 
                type="button"
                id='cancel-tp'
                label='Cancel'
                onClick={(handleCancel)}
                className="create btn-bottom btn-bottom-cancel"
                content={`Cancel creation`}
              />

              <button id='save-tp' className="create btn-bottom btn-bottom-create" style={{ marginLeft: 10, minWidth: "auto" }}>Create</button>
              <Tooltip anchorSelect="#save-tp" content={"Save changes"} place={"top"} />
            </div>
            <span className='errors-msg'  >{errors.name}</span>
          </form>
        </div>
        <SelectCodeModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          setValue={setInputContext}
        />
      </div>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
    </div>
  )
}
